import React from 'react';
import PropTypes from 'prop-types';

import { ArrowRightIcon } from "@heroicons/react/solid";

import './Teaching.css';

const Teaching = () => (

  <section id="teaching" className="min-h-screen bg-cover bg-fixed bg-right lg:bg-teaching-pattern bg-white">
    <div className="lg:w-1024 md:w-full sm:w-full mx-auto flex px-8 py-24 flex-col">
      <div className="w-full mb-8 lg:w-1/2 flex flex-col items-start text-left">
        <h1 className="w-full text-2xl sm:text-4xl font-bold title-font mb-4 text-black">
          Teaching
        </h1>
        <p className="w-full text-black text-lg tracking-widest">
          Undergraduate and graduate courses at Universidad Carlos III de Madrid.
        </p> <br />
        <h1 className="text-black text-2xl font-medium mb-3 tracking-widest">Undergraduate Courses</h1>
        <ul className="mb-12">
          <li className="mb-8 text-black">
            <h2 className="text-lg font-medium tracking-widest">Programming (2013&#8212; )</h2>
            <p className="text-lg italic">Bachelor in Telematics Engineering</p>
            <p className="text-base tracking-widest">Introduction to computer programming in Java.</p>
            <a href="https://aplicaciones.uc3m.es/cpa/generaFicha?est=215&anio=2021&plan=447&asig=13405&idioma=2"
              target="_blank"
              className="tracking-widest mt-1 inline-flex text-black border border-black py-2 px-2 focus:outline-none hover:bg-gray-500 hover:text-gray-100 rounded text-base">
               description
              <ArrowRightIcon className="w-4 h-4 ml-1 mt-1" />
            </a>
          </li>
          <li className="mb-5 text-black">
            <h2 className="text-lg font-medium tracking-widest">Ubiquitous Computing (2013&#8212;2022)</h2>
            <p className="text-lg italic">Bachelor in Computer Science and Engineering</p>
            <p className="text-base tracking-widest">Ubiquitous computing fundamentals. Interaction design for ubiquitous systems. Web technolgies for ubiquitous interaction.</p>
            <a href="https://aplicaciones.uc3m.es/cpa/generaFicha?est=218&anio=2021&plan=431&asig=15989&idioma=2"
              target="_blank"
              className="tracking-widest mt-1 inline-flex text-black border border-black py-2 px-2 focus:outline-none hover:bg-gray-500 hover:text-gray-100 rounded text-base">
               description
              <ArrowRightIcon className="w-4 h-4 ml-1 mt-1" />
            </a>
          </li>
        </ul>

        <h1 className="text-black text-2xl font-medium mb-3 tracking-widest">Graduate Courses</h1>
        <ul>
          <li className="mb-5 text-black">
            <h2 className="text-lg font-medium tracking-widest">Interactive and Immersive Systems (2020&#8212; )</h2>
            <p className="text-lg italic">Master in Computer Engineering</p>
            <p className="text-base tracking-widest">Design guidelines and interaction design for AR/VR/MR. Development of immersive systems with the WebXR API, A-Frame, three.js and Unity.</p>
            <div className="flex flex-row">
              <a href="https://andreabellucci.github.io/inmersivos/"
                target="_blank"
                className="mt-1 mr-3 inline-flex text-white bg-black border border-black py-2 px-2 focus:outline-none hover:bg-gray-500 hover:text-gray-100 rounded text-base">
                 webpage
                <ArrowRightIcon className="w-4 h-4 ml-1 mt-1" />
              </a>
              <a href="https://aplicaciones.uc3m.es/cpa/generaFicha?est=228&anio=2021&plan=449&asig=18652&idioma=2"
                target="_blank"
                className="tracking-widest mt-1 mr-2 inline-flex text-black border border-black py-2 px-2 focus:outline-none hover:bg-gray-500 hover:text-gray-100 rounded text-base">
                 description
                <ArrowRightIcon className="w-4 h-4 ml-1 mt-1" />
              </a>

            </div>
          </li>
        </ul>
      </div>
    </div>
  </section>
);

Teaching.propTypes = {};

Teaching.defaultProps = {};

export default Teaching;
